class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.dots = this.querySelectorAll(`.main-product__media__dots__dot`);
    this.prev = this.querySelector(`.main-product__media__dots__prev`);
    this.next = this.querySelector(`.main-product__media__dots__next`);
    this.count = this.querySelector(
      `.main-product__media__dots__count span:first-child`
    );

    if (!this.dots.length != 0 || !this.prev || !this.next) return;

    // Initialize active dot as the first dot
    this.activeDotIndex = 0;
    this.setActiveDot(this.activeDotIndex);

    this.setupListener();
  }

  setupListener() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        this.activeDotIndex = index;
        this.setActiveDot(this.activeDotIndex);
        const mediaId = this.dots[this.activeDotIndex].dataset.mediaDotId;
        this.updateMedia(mediaId);
      });
    });

    this.prev.addEventListener("click", () => {
      this.activeDotIndex = (this.activeDotIndex - 1 + this.dots.length) % this.dots.length;
      this.setActiveDot(this.activeDotIndex);
      this.updateCount(-1);
      let activeDot;
      this.dots.forEach(dot => {
        if (dot.classList.contains('__active')) {
          activeDot = dot;
        }
      });
      this.updateMedia(activeDot.dataset.mediaDotId);
    });

    this.next.addEventListener("click", () => {
      this.activeDotIndex = (this.activeDotIndex + 1) % this.dots.length;
      this.setActiveDot(this.activeDotIndex);
      this.updateMedia(this.dots[this.activeDotIndex].dataset.mediaDotId);
      this.updateCount(1);
    });
  }

  setActiveMedia(mediaId) {
  const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
  if (!activeMedia) return;

  activeMedia.parentElement.prepend(activeMedia);
  this.setActiveDot(mediaId);
}

  updateMedia(mediaId) {
    const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
    if (!activeMedia) return;

    activeMedia.parentElement.prepend(activeMedia);
  }

  setActiveDot(index) {
    this.dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add("__active");
      } else {
        dot.classList.remove("__active");
      }
    });
  }

  updateCount(increase) {
    this.count.innerHTML = parseInt(this.count.innerHTML) + increase;
  }
}

customElements.define("media-gallery", MediaGallery);
